/**
 * Created by Vladislav on 18.09.2024.
 */

cleverapps.InitConfigByType["merge"] = function () {
    Families.initialize();
};

cleverapps.InitByType["merge"] = function () {
    Pocket.initialize();
    CustomerRecipe.initialize();

    AdventureExpedition.initialize();

    Landmarks.initialize();

    if (typeof StopHustlemergeFeatures !== "undefined") {
        StopHustlemergeFeatures();
    }

    cleverapps.unitsSyncers = new UnitsSyncers();

    cleverapps.unitsShop = new UnitsShop();

    cleverapps.specialEnergyOffer = new SpecialEnergyOffer();

    cleverapps.tutorial.register(Merge3BaseTutorial());
    cleverapps.tutorial.register(Merge3ChestTutorial());
    cleverapps.tutorial.register(Merge3BuildTutorial());
    cleverapps.tutorial.register(Merge3UnitTradeTutorial());
    cleverapps.tutorial.register(FriendBalloonTutorial());
    cleverapps.tutorial.register(UnitsShopTutorial());

    Map2dLocation.TUTORIALS.forEach((tutorial) => {
        cleverapps.tutorial.register(tutorial());
    });
};